<template>
  <div class="breadcrumbs">
    <ul class="breadcrumbs__list">
      <li v-for="(item, index) in list" :key="index" class="breadcrumbs__listItem">
        <component
          :is="searchPage ? 'nuxt-link' : 'button'"
          v-if="lastClickable || index !== list.length - 1"
          :to="url(item)"
          class="breadcrumbs__listLink"
          :class="{ 'breadcrumbs__listLink--chevron': item.list }"
          @click="onClick(item)"
        >
          {{ item.title }}
        </component>
        <span v-if="index !== list.length - 1" class="breadcrumbs__listSlash">/</span>
        <span
          v-if="index === list.length - 1 && !lastClickable"
          class="breadcrumbs__listLink breadcrumbs__listLink--last"
        >
          {{ item.title }}
        </span>
        <dropdown v-if="item.list && list.length - 1 !== index" class="breadcrumbs__listDropdown">
          <ul class="breadcrumbs__dropdown">
            <li
              v-for="(listItem, listItemIndex) in item.list"
              :key="listItemIndex"
              class="breadcrumbs__dropdownItem"
            >
              <component
                :is="searchPage ? 'nuxt-link' : 'button'"
                :to="url(listItem)"
                class="breadcrumbs__dropdownLink"
                @click="onClick(listItem)"
              >
                {{ listItem.title }}
              </component>
            </li>
          </ul>
        </dropdown>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Dropdown from './Dropdown';

export default {
  name: 'Breadcrumbs',
  components: {
    Dropdown,
  },
  props: {
    list: {
      type: Array,
      default: undefined,
    },
    lastClickable: {
      type: Boolean,
      default: false,
    },
    searchPage: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    ...mapActions({
      changeCategory: 'productsFilters/changeCategory',
    }),
    url(item) {
      if (item.to) {
        return item.to;
      } else if (this.searchPage && item.slug) {
        return this.localePath({
          name: 'category-slug',
          params: { slug: item.slug },
          ...(!item.showCategoryView && { query: this.$route.query }),
        });
      } else if (!this.searchPage && item.slug) {
        return this.localePath({
          name: 'search',
          query: { 'categories[]': item.id },
        });
      } else if (item.slug) {
        return item.slug;
      } else {
        return '/';
      }
    },
    onClick(item) {
      if (!this.searchPage && item.slug) {
        this.changeCategory({ type: 'search', value: [item.id] });
      }
    },
  },
};
</script>

<style lang="scss">
.breadcrumbs {
  $root: &;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;

  &__list {
    display: flex;

    @include rwd('large-tablet') {
      overflow: auto;
    }
  }

  &__listItem {
    position: relative;
    display: flex;
    font-size: 1.4rem;
    line-height: 3rem;

    &:hover {
      #{$root}__listDropdown {
        opacity: 1;
        pointer-events: all;
      }

      #{$root}__listLink {
        color: $cMainNeutral;
      }

      #{$root}__dropdown {
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  &__listLink {
    color: $cAddDark02;
    white-space: nowrap;
    transition: color $tr;

    &--last {
      color: $cMainNeutral;
    }

    &--chevron {
      &:after {
        @include icomoon('chevron-down');
        position: relative;
        top: -2px;
        font-size: 0.5rem;
        padding-left: 5px;

        @include rwd('large-tablet') {
          display: none;
        }
      }
    }
  }

  &__listSlash {
    padding-left: 10px;
    padding-right: 10px;
    color: $cAddDark02;
  }

  &__listDropdown {
    padding-top: 1rem;
    right: 1.2rem;
    width: max-content;
    max-width: 220px;

    @include rwd('large-tablet') {
      display: none;
    }
  }

  &__dropdown {
    max-width: 250px;
    width: 100%;
  }

  &__dropdownItem {
    transition: color $tr;

    &:hover {
      color: $cSec;
    }
  }

  &__dropdownLink {
    /*display: block;*/
    text-align: left;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }
  }
}
</style>
